module.exports = __webpack_public_path__ + "media/src/images/dandori/step4-5ee4650320947d5b6980faed592c2e8e.png";